import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ProductionScheduleErrors} from '@domain/production-schedule/production-schedule-errors';
import {Message, TranslateService} from '@vdw/angular-component-library';
import {isNil} from 'lodash-es';

@Component({
  templateUrl: './production-schedule-colored-yarn-set-error-popup.component.html',
  styleUrls: ['./production-schedule-colored-yarn-set-error-popup.component.scss']
})
export class ProductionScheduleColoredYarnSetErrorPopupComponent {
  private errors: ProductionScheduleErrors;
  private translate: TranslateService;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    translate: TranslateService
  ) {
    this.errors = data.errors;
    this.translate = translate;
  }

  public getMessages(): Message[] {
    const result = [];

    if (this.canShowErrorTotalWidthTooBig()) {
      const description = this.translate.instant('PRODUCTION_ORDER.ERRORS.COLORED_YARN_SET_WIDTH_TOO_BIG', {value: this.errors.totalWidthTooBig});
      result.push(Message.createErrorMessageWithDescription(description));
    }

    if (this.canShowErrorTotalWidthTooLittle()) {
      const description = this.translate.instant('PRODUCTION_ORDER.ERRORS.COLORED_YARN_SET_WIDTH_TOO_LITTLE', {value: this.errors.totalWidthTooLittle});
      result.push(Message.createErrorMessageWithDescription(description));
    }

    return result;
  }

  private canShowErrorTotalWidthTooBig(): boolean {
    return !isNil(this.errors.totalWidthTooBig);
  }

  private canShowErrorTotalWidthTooLittle(): boolean {
    return !isNil(this.errors.totalWidthTooLittle);
  }
}
